import { call, put, takeLatest, select } from 'redux-saga/effects'
import { ContractHashChipNFTRewards, ifaceContractHashChipNFTRewards } from '~/blockchain/contract'
import { ethersWeb3Provider } from '~/blockchain/oas'
import { ethers } from 'ethers'
import { checkTransactionConfirmation, hexToNumberString, numberToHex, toWei } from '~/blockchain/provider'
import { changeNetworkInMetamask } from '~/blockchain/metamask'
import configs from '~/configs'

// Action Types
const WITHDRAW_HASH_CHIP_POOL_START = 'WITHDRAW_HASH_CHIP_POOL_START'
const WITHDRAW_HASH_CHIP_POOL_SUCCESS = 'WITHDRAW_HASH_CHIP_POOL_SUCCESS'
const WITHDRAW_HASH_CHIP_POOL_FAILED = 'WITHDRAW_HASH_CHIP_POOL_FAILED'

function* handleWithDrawHashChipPool(action) {
  try {
    const { payload, onSuccess } = action
    const wallet = localStorage.getItem('wallet')

    if (wallet === 'OAS') {
      // OAS Wallet Flow
      const signer = ethersWeb3Provider.getSigner()
      const contract = ContractHashChipNFTRewards.connect(signer)
      const amount = ethers.utils.parseEther(payload.amount.toString())

      const tx = yield call([contract, contract.deposit], { value: amount })
      yield call([tx, tx.wait])

      yield put({ type: WITHDRAW_HASH_CHIP_POOL_SUCCESS, payload })
      if (onSuccess) yield call(onSuccess)

    } else {
      // MetaMask Flow
      const provider = window.ethereum
      if (!provider) throw new Error('MetaMask not installed')

      yield call([provider, provider.request], { method: 'eth_requestAccounts' })

      // Change network if needed
      const networkId = yield call([provider, provider.request], {
        method: 'eth_chainId'
      })

      if (hexToNumberString(networkId) !== configs.NETWORK.chainId.toString()) {
        yield call(changeNetworkInMetamask, provider, configs.NETWORK.chainId)
      }

      const accounts = yield call([provider, provider.request], {
        method: 'eth_accounts'
      })

      const from = accounts[0]
      if (!from) throw new Error('No account selected')

      const nonce = yield call([provider, provider.request], {
        method: 'eth_getTransactionCount',
        params: [from, 'latest']
      })

      const txHash = yield call([provider, provider.request], {
        method: 'eth_sendTransaction',
        params: [{
          from,
          to: configs.ADDRESS_HASHCHIP_NFT_REWARDS,
          data: ifaceContractHashChipNFTRewards.encodeFunctionData('withdraw', [
            toWei(payload?.amount)
          ]),
          // value: numberToHex(toWei(payload.amount)),
          nonce
        }]
      })

      // Wait for confirmation
      const result = yield call(checkTransactionConfirmation, txHash)
      if (result === 'confirmed') {
        yield put({ type: WITHDRAW_HASH_CHIP_POOL_SUCCESS, payload })
        if (onSuccess) yield call(onSuccess)
      } else {
        throw new Error('Transaction failed')
      }
    }

  } catch (error) {
    console.error(error)
    yield put({ type: WITHDRAW_HASH_CHIP_POOL_FAILED })
    if (action.onError) yield call(action.onError, error)
  }
}

export default function* watchWithDrawHashChipPool() {
  yield takeLatest(WITHDRAW_HASH_CHIP_POOL_START, handleWithDrawHashChipPool)
}